import { Button } from '../../components/form/button';
import React, { useContext } from 'react';
import { AdminContext } from '../../context/admin-context';
import { TenantContext } from '../../context/tenant-context';
import classNames from 'classnames';

export const QuipliMate = () => {
  const { email } = useContext(AdminContext);
  const { tenant } = useContext(TenantContext);
  const quipliMateRef = React.useRef<HTMLIFrameElement>(null);

  const openQuipliMateWidget = () => {
    quipliMateRef.current?.contentWindow?.postMessage({ msg: 'openQuipliMate', userId: `${tenant}-${email}` }, '*');
    quipliMateRef.current?.classList.remove('w-1', 'h-1');
    quipliMateRef.current?.classList.add(
      'z-50',
      'sm:w-fit',
      'sm:h-fit',
      'w-full',
      'h-full',
      'min-h-[50vh]',
      'min-w-[30vw]',
    );
    document.querySelector('#quiplimate-button')?.classList.remove('z-[100]');
    document.querySelector('#quiplimate-button')?.classList.add('z-[-1]');
  };

  window.addEventListener('message', (event) => {
    if (event.data === 'closeQuipliMate') {
      quipliMateRef.current?.classList.add('w-1', 'h-1');
      quipliMateRef.current?.classList.remove(
        'z-50',
        'sm:w-fit',
        'sm:h-fit',
        'w-full',
        'h-full',
        'min-h-[50vh]',
        'min-w-[30vw]',
      );
      document.querySelector('#quiplimate-button')?.classList.add('z-[100]');
      document.querySelector('#quiplimate-button')?.classList.remove('z-[-1]');
    }
  });

  return (
    <div className={`quiplimate-copilot fixed right-0 bottom-0 z-[100]  `}>
      <iframe
        className="fixed right-0 bottom-0 z-[-1] w-1 h-1"
        id="quiplimate-iframe"
        src="https://quipli-service-prod-public.s3.amazonaws.com/quiplimate-copilot.html"
        ref={quipliMateRef}
      ></iframe>
      <Button
        className={classNames('w-[40px] h-[40px] rounded-full z-[100] fixed right-4 bottom-4 border-none')}
        id="quiplimate-button"
        onClick={() => openQuipliMateWidget()}
      >
        <img
          loading="lazy"
          src="https://ghexww3n55fveb5i.public.blob.vercel-storage.com/eyJ0eXBlIjoicHJveHkiLCJzcmMiOiJodHRwczovL2ltYWdlcy5jbGVyay5kZXYvdXBsb2FkZWQvaW1nXzJiNVBORGFpS21MOWVFTmZMSXBZVHdLYVJCMCJ9-sfPIiNiuWnxPWus0SaBB1F5hNKoAAv.avif"
          className="rounded-full w-[40px] h-[40px]"
        />
      </Button>
    </div>
  );
};
